import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";

const ClientInformation = ({
  title,
  info,
  variant = "default",
  onModify,
  disabled,
}) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS);
  const PRODUCT_CARD = t("PRODUCT_CARD", { returnObjects: true });

  return (
    <div className={`client__information client__information--${variant}`}>
      <h3 className="client__information--title">{title}</h3>
      <div className="client__information--content">
        {info.map(({ label, value }, index) => (
          <div key={index} className="client__information--item">
            <span className="client__information--label">{label}</span>
            <span className="client__information--value">{value}</span>
          </div>
        ))}
      </div>
      {onModify && variant === "client" && (
        <div className="action">
          <Button
            type="primary--underline"
            onClick={onModify}
            className="btn--modify"
            disabled={disabled}
          >
            {PRODUCT_CARD.EDIT}
          </Button>
        </div>
      )}
    </div>
  );
};

ClientInformation.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  variant: PropTypes.oneOf(["default", "client"]),
  onModify: PropTypes.func,
};

export default ClientInformation;
